// Mock data for development and testing

export const mockTestimonials = [
    {
        id: 1,
        name: "John Doe",
        company: "Solar Corp",
        role: "Project Manager",
        content: "Alignworx has transformed our solar installation process.",
        rating: 5
    }
];

export const mockProjects = [];
export const mockTeams = [];
export const mockSchedulerJobs = [];
export const mockKPIs = [];
export const mockPricingRates = [];
export const mockOEMs = [];

export const paymentTerms = {
    booking: {
        percentage: 40,
        description: "Minimum 3 days before scheduled installation date"
    },
    second: {
        percentage: 40,
        description: "One day before installation start date"
    },
    final: {
        percentage: 20,
        description: "One day before completion/delivery"
    }
};

export const refundPolicy = [
    {
        type: 'cancellation',
        daysBeforeBooking: '7+',
        refundPercentage: 100,
        description: 'Full refund if cancelled 7 or more days before scheduled date'
    },
    {
        type: 'cancellation',
        daysBeforeBooking: '3-6',
        refundPercentage: 50,
        description: '50% refund if cancelled 3-6 days before scheduled date'
    },
    {
        type: 'cancellation',
        daysBeforeBooking: '0-2',
        refundPercentage: 0,
        description: 'No refund if cancelled within 2 days of scheduled date'
    },
    {
        type: 'reschedule',
        daysBeforeBooking: 'Any',
        refundPercentage: 100,
        description: 'Free rescheduling available once, 100% amount adjustable to new date'
    }
];

export const progressItems = [
    { id: 1, label: "Not Started", value: "not_started" },
    { id: 2, label: "In Progress", value: "in_progress" },
    { id: 3, label: "Completed", value: "completed" }
];

export const reportWindows = [
    { id: 1, label: "Daily", value: "daily" },
    { id: 2, label: "Weekly", value: "weekly" }
];

export const designationOptions = [
    { id: 1, label: "Aligner", value: "installer" },
    { id: 2, label: "Technician", value: "technician" },
    { id: 3, label: "SuperAligner", value: "supervisor" }
];

export const skillLevels = [
    { id: 1, label: "Junior", value: "junior" },
    { id: 2, label: "Intermediate", value: "intermediate" },
    { id: 3, label: "Senior", value: "senior" },
    { id: 4, label: "Expert", value: "expert" }
];

export const bloodGroups = [
    { id: 1, label: "A+", value: "a_positive" },
    { id: 2, label: "A-", value: "a_negative" },
    { id: 3, label: "B+", value: "b_positive" },
    { id: 4, label: "B-", value: "b_negative" },
    { id: 5, label: "AB+", value: "ab_positive" },
    { id: 6, label: "AB-", value: "ab_negative" },
    { id: 7, label: "O+", value: "o_positive" },
    { id: 8, label: "O-", value: "o_negative" }
];
